import type { IApiResponse, IPagination } from "@/api";
import * as socialMediaSVG from "@/assets/socialMedia";
import { ISocialMedia } from "@/interfaces";

const socialMediaImg: Record<ISocialMedia, string> = {
  // Discord: socialMediaSVG.Discord,
  // Facebook: socialMediaSVG.Facebook,
  [ISocialMedia.github]: socialMediaSVG.Github,
  // Google: socialMediaSVG.Google,
  // Instagram: socialMediaSVG.Instagram,
  [ISocialMedia.linkedin]: socialMediaSVG.Linkedin,
  [ISocialMedia.medium]: socialMediaSVG.Medium,
  [ISocialMedia.orcid]: socialMediaSVG.Orcid,
  // Skype: socialMediaSVG.Skype,
  // Telegram: socialMediaSVG.Telegram,
  // Threads: socialMediaSVG.Threads,
  // Twitter_X: socialMediaSVG.Twitter_X,
  [ISocialMedia.whatsapp]: socialMediaSVG.Whatsapp,
  // Youtube: socialMediaSVG.Youtube,
};

export function getSocialMediaSVG(name: ISocialMedia) {
  return socialMediaImg[name];
}

export const collectionMapperFunc = <TApi, TData>(
  data: IApiResponse<IPagination<TApi>>,
  mapper: (data: TApi) => TData,
): IPagination<TData> => {
  return {
    ...data?.data,
    items: data?.data?.items?.map((item) => mapper(item)),
  };
};
